import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  Drug,
  FilterDetails,
  MedicalTest,
  CartQuantityItem,
  OtherServices,
  Search,
  QuantityDetails
} from '../../models';
import { DataService } from '../../services';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-service-sidebar',
  templateUrl: './service-sidebar.component.html',
  styleUrls: ['./service-sidebar.component.scss']
})

export class ServiceSidebarComponent implements OnInit {
  @Input() medicalTest: MedicalTest;
  @Input() drug: Drug;
  @Input() cartItems: MedicalTest[] | Drug[] = [];
  @Input() otherService: OtherServices;
  @Input() isShowAddCart: boolean;
  @Input() isMedicalConsultation: boolean;
  @Input() selectedQuantity: QuantityDetails;
  @Input() isUpdate: { [drugId: number]: boolean } = {};
  @Input() productQuantities: CartQuantityItem[] = [];
  isChecked: boolean = false;
  medicalTestCategories: FilterDetails[] = [];
  drugCategories: FilterDetails[] = [];
  medicalTests: MedicalTest[] = [];
  drugs: Drug[] = [];
  categoryCounts: { [key: string]: number } = {};
  isLoggedIn: Observable<boolean>;

  constructor(
    private dataService: DataService,
    private router: Router,
   ) {}

  ngOnInit(): void {
    this.medicalTestCategories = this.dataService.getLocalFilterDetails();
    this.drugCategories = this.dataService.getPharmacyFilterDetails();
    this.dataService.getAllLocalMedicalTests().pipe(
      mergeMap(medicalTests => {
        this.medicalTests = medicalTests as MedicalTest[];
        return this.dataService.getAllLocalDrugs()
      })).subscribe(drugs => {
          this.drugs = drugs as Drug[];
        this.categoryCounts = this.getProductCountsByCategory([...this.medicalTests, ...this.drugs]);
    });
  }

  getProductCountsByCategory(products: (MedicalTest | Drug)[]): { [key: string]: number } {
    return products.reduce((counts: { [key: string]: number }, test: MedicalTest | Drug) => {
      counts[test.category] = (counts[test.category] || 0) + 1;
      return counts;
    }, {});
  }

  addToCart(product: MedicalTest | Drug, selectedQuantity?: QuantityDetails) {
    const cartHasDrug= this.cartItems.some(item => ('country_of_origin' in item));
    const isDrug = 'country_of_origin' in product;
    if (cartHasDrug && !isDrug) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'You can only add either a medical test or a drug to the cart at a time.',
        confirmButtonColor: '#f37b7b',
      });
      return;
    }
    this.dataService.addProductToCart(product, selectedQuantity);
    if (isDrug) {
      this.refreshCartState(product.id, selectedQuantity);
    }
  }

  refreshCartState(drugId?: number, selectedType?: QuantityDetails): void {
    const { cartItems, quantities } = this.dataService.refreshCartState();
    this.cartItems = cartItems;
    this.productQuantities = quantities;
    if (drugId) {
      this.isUpdate[drugId] = false;
    }
  }

  updateMedicalTestQuantities() {
    this.dataService.updateMedicalTestQuantities()
  }

  filterProducts(searchCriteria: Search, product: 'medicalTests' | 'drugs') {
    this.dataService.saveLocalSearchCriteria(searchCriteria, product);
    if (product === 'medicalTests') {
      this.router.navigateByUrl('medical-tests');
    } else {
      this.router.navigateByUrl('pharmacy');
    }
  }
}
